export type LensDataVersionState = {
  lensId?: string;
  version?: number;
  pending: boolean;
};

/** A saved definition change makes its previous card results stale, even after drafting ends. */
export function lensDataVersionRefresh(
  previous: LensDataVersionState,
  current: {
    lensId?: string;
    version?: number;
    isFetching: boolean;
    dataUpdatedAt?: number;
    savedAt?: number;
  },
): { state: LensDataVersionState; refresh: boolean } {
  const sameLens = Boolean(current.lensId) && current.lensId === previous.lensId;
  const changed = sameLens && previous.version !== undefined && current.version !== previous.version;
  const olderCachedData =
    Boolean(current.lensId) &&
    !sameLens &&
    (current.dataUpdatedAt ?? 0) > 0 &&
    Number.isFinite(current.savedAt) &&
    current.dataUpdatedAt! < current.savedAt!;
  const pending = olderCachedData || (sameLens && (previous.pending || changed));
  // Let an older request finish, then refresh the latest version once. Cancelling it can
  // start a second warehouse read while the first continues to run on the server.
  const refresh = pending && !current.isFetching && current.version !== undefined;
  return {
    state: { lensId: current.lensId, version: current.version, pending: pending && !refresh },
    refresh,
  };
}
